import React, { useRef, useEffect, useState } from "react";
import Tree from "react-d3-tree";
import { useProvider } from '../context/MenuProvider';

function App() {
  const treeContainer = useRef(null);
  const [translate, setTranslate] = useState({ x: 0, y: 0 });
  const [selectedNodes, setSelectedNodes] = useState(new Set());
  const [consultores, setConsultores] = useState([]);
  const { userAdmin, crudAdmin, salvarDados } = useProvider();
  const { get } = crudAdmin || {};

  // Converte lista plana em árvore
  const buildTree = list => {
    const map = {};
    let root = null;

    list.forEach(item => {
      map[item.id] = { 
        ...item, 
        name: (item?.nome || item.contato?.nome_do_cliente || item.codigo)?.trim().split(' ')[0], 
        children: [] 
      };
    });

    list.forEach(item => {
      if (item.parent === null) {
        root = map[item.id];
      } else if (map[item.parent]) {
        map[item.parent].children.push(map[item.id]);
      }
    });

    return root;
  };

  const treeData = consultores.length
    ? buildTree(consultores)
    : { id: 0, name: userAdmin?.nome_da_loja?.trim().split(' ')[0], children: [] };

  // Busca todos os consultores, paginando até acabar
  const buscarConsultor = async (novaBusca = false) => {
    try {
      let url = `/rede/consultores/?ordering=nome&limit=200&expand=contato`;
      let todosResultados = [];
      let page = 1;

      while (url) {
        console.log(`Carregando página ${page}...`);
        const response = await get(url, 'pagina');
        if (response && response[0]?.results) {
          todosResultados = [...todosResultados, ...response[0].results];
          url = response[0]?.next; // pega o próximo
          page++;
        } else {
          url = null;
        }
      }

      if (todosResultados.length) {
        const euList = [
          { id: 0, nome: `${userAdmin?.nome_da_loja?.trim().split(' ')[0]}`, parent: null }
        ];
        const novosItens = [
          ...euList,
          ...todosResultados.map(item => ({ ...item, parent: item.upline || 0 }))
        ];
        setConsultores(novaBusca ? novosItens : [...consultores, ...novosItens]);
        await salvarDados("db_consultores", novosItens);
      }
    } catch (err) {
      console.error("Erro ao buscar consultores", err);
    }
  };

  useEffect(() => {
    if (treeContainer.current) {
      const { width } = treeContainer.current.getBoundingClientRect();
      setTranslate({ x: width / 2, y: 50 });
    }
    buscarConsultor(true);
  }, []);

  const getAllDescendants = node => {
    let ids = [node.id];
    if (node.children) {
      node.children.forEach(child => {
        ids = ids.concat(getAllDescendants(child));
      });
    }
    return ids;
  };

  const handleClick = nodeDatum => {
    const allIds = getAllDescendants(nodeDatum);
    setSelectedNodes(new Set(allIds));
  };

  const renderNodeWithColor = ({ nodeDatum }) => {
    const isSelected = selectedNodes.has(nodeDatum.id);
    return (
      <g>
        <foreignObject width={120} height={80} x={-60} y={-40}>
          <div
            onClick={() => handleClick(nodeDatum)}
            style={{
              border: `2px solid ${nodeDatum?.pre_cadastro?'red':'#007bff'}`,
              borderRadius: "8px",
              background: isSelected ? "#ffeb3b" : "#e6f0ff",
              textAlign: "center",
              width: "120px",
              height: "80px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <i className="bx bx-user-circle" style={{ fontSize: "24px", marginBottom: 4 }}></i>
            <div>
              {nodeDatum?.pre_cadastro && (<>*</>)}
              {nodeDatum.name}
            </div>
          </div>
        </foreignObject>
      </g>
    );
  };

  return (
    <div ref={treeContainer} style={{ height: "100vh" }}>
      <Tree
        data={treeData}
        translate={translate}
        renderCustomNodeElement={renderNodeWithColor}
        orientation="vertical"
        pathFunc="elbow"
      />
    </div>
  );
}

export default App;